<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <!-- Profiles Columns -->
    <div
      class="modal fade"
      id="profiles-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">{{ $t("profiles.profiles_columns") }}</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="Profile"
                        v-model="columns.name.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="description"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-file"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.description") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="description"
                        v-model="columns.description.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-playstation-circle"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="firstname"
                        v-model="columns.enabled.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-cloud"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.service") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="lastname"
                        v-model="columns.service.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="username"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-list-letters"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.type") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="username"
                        v-model="columns.type.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Password"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-tags"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.price") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="Password"
                        v-model="columns.price.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="mobileNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-speedtest"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.speed_limit") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="mobileNumber"
                        v-model="columns.speed.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-stats"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.expiration") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="lineNumber"
                        v-model="columns.expiration.enabled"
                        @change="updateColumns"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-package"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.quota") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.quota.enabled"
                        @change="updateColumns"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-packages"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.ip_pool") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.ip_pool.enabled"
                        @change="updateColumns"
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-users"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.total_accounts") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.total_accounts.enabled"
                        @change="updateColumns"
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="expirationDate"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user-check"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.online_accounts") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.online_accounts.enabled"
                        @change="updateColumns"
                        id="expirationDate"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="openSpeed"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-speedtest"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.open_speed") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.open_speed.enabled"
                        @change="updateColumns"
                        id="openSpeed"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="profileShared"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-share"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.shared") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.shared.enabled"
                        @change="updateColumns"
                        id="profileShared"
                      />
                    </label>
                  </div>
                </div>

                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="expirationProfile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-exclamation"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.expiration_profile") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.expiration_profile.enabled"
                        @change="updateColumns"
                        id="expirationProfile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-network"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.allowed_nases") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.allowed_nases.enabled"
                        @change="updateColumns"
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ARenew"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user-shield"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.allowed_admins") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.allowed_admins.enabled"
                        @change="updateColumns"
                        id="ARenew"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="customAttributes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-grid-pattern"></i>
                        <span class="custom-option-title">
                          {{ $t("profiles.custom_attributes") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.custom_attributes.enabled"
                        @change="updateColumns"
                        id="customAttributes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="createdAt"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">
                          {{ $t("control.created_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        id="createdAt"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /// -->
    <profilesAdd
      v-if="showAddProfile && hasPrivilege('profiles_edit_profiles')"
      :visible="showAddProfile"
      @updated="
        $router.push({ query: {} });
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="dt-buttons flex" bis_skin_checked="1">
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    v-if="hasPrivilege('profiles_edit_profiles')"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    @click="openAddProfileDialog"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("profiles.add_profile") }}</span>
                    </span>
                  </button>
                  <div class="d-flex align-items-center mx-4">
                    <InfoButton
                      :url="'https://www.youtube.com/watch?v=e7gW226Y754'"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('profiles_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('profiles_table', 'profiles')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('profiles_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    class="form-control"
                    v-if="hasPrivilege('profiles_view_search_profiles')"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#profiles-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>
            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="profiles_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <!-- <li v-if="hasPrivilege('profiles_disable_profiles')">
                            <button class="dropdown-item text-warning" href="#">
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disable") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('profiles_delete_profiles')">
                            <button class="dropdown-item text-danger" href="#">
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li> -->
                        </ul>
                      </div>
                    </th>
                    <th>
                      <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      /> -->
                    </th>
                    <th class="sorting" v-if="columns.name.enabled">
                      {{ $t("profiles.name") }}
                    </th>
                    <th class="sorting" v-if="columns.description.enabled">
                      {{ $t("profiles.description") }}
                    </th>
                    <th class="sorting" v-if="columns.enabled.enabled">
                      {{ $t("profiles.status") }}
                    </th>
                    <th class="sorting" v-if="columns.service.enabled">
                      {{ $t("profiles.service") }}
                    </th>
                    <th class="sorting" v-if="columns.type.enabled">
                      {{ $t("profiles.type") }}
                    </th>
                    <th class="sorting" v-if="columns.price.enabled">
                      {{ $t("profiles.price") }}
                    </th>
                    <th class="sorting" v-if="columns.speed.enabled">
                      {{ $t("profiles.speed_limit") }}
                    </th>
                    <th class="sorting" v-if="columns.expiration.enabled">
                      {{ $t("profiles.expiration") }}
                    </th>
                    <th class="sorting" v-if="columns.quota.enabled">
                      {{ $t("profiles.quota") }}
                    </th>
                    <th class="sorting" v-if="columns.ip_pool.enabled">
                      {{ $t("profiles.ip_pool") }}
                    </th>
                    <th class="sorting" v-if="columns.total_accounts.enabled">
                      {{ $t("profiles.total_accounts") }}
                    </th>
                    <th class="sorting" v-if="columns.online_accounts.enabled">
                      {{ $t("profiles.online_accounts") }}
                    </th>
                    <th class="sorting" v-if="columns.open_speed.enabled">
                      {{ $t("profiles.open_speed") }}
                    </th>
                    <th class="sorting" v-if="columns.shared.enabled">
                      {{ $t("profiles.shared") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.expiration_profile.enabled"
                    >
                      {{ $t("profiles.expiration_profile") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_nases.enabled">
                      {{ $t("profiles.allowed_nases") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_admins.enabled">
                      {{ $t("profiles.allowed_admins") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.custom_attributes.enabled"
                    >
                      {{ $t("profiles.custom_attributes") }}
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      {{ $t("control.created_at") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('profiles_view_search_profiles')">
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.name"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.description.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.enabled.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.enabled"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="0">{{ $t("control.disabled") }}</option>
                        <option value="1">{{ $t("control.enabled") }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.service.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.service"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="any">Any</option>
                        <option value="hotspot">Hotspot</option>
                        <option value="ppp">PPP</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.type.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.type"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="subscribtion">{{
                          $t("profiles.subscription")
                        }}</option>
                        <option value="prepaid">{{
                          $t("profiles.prepaid")
                        }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.price.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.price"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.speed.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.speed"
                        @change="applyFilters"
                      />
                    </th>
                    <th v-if="columns.expiration.enabled"></th>
                    <th
                      v-if="columns.quota.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.quota"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.ip_pool.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.ip_pool"
                        @change="applyFilters"
                      />
                    </th>
                    <th v-if="columns.total_accounts.enabled"></th>
                    <th v-if="columns.online_accounts.enabled"></th>
                    <th
                      v-if="columns.open_speed.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.open_speed"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.shared.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.shared"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.expiration_profile.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.expiration_profile"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th v-if="columns.allowed_nases.enabled"></th>
                    <th v-if="columns.allowed_admins.enabled"></th>
                    <th
                      v-if="columns.custom_attributes.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        id="selectpickerBasic"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="filters.custom_attributes"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        v-model="filters.created_at"
                        @change="applyFilters"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(profile, index) in dataList" :key="profile.id">
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('profiles_edit_profiles')">
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="openAddProfileDialog(profile)"
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('profiles_edit_profiles')">
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="
                                openAddProfileDialog(profile, 'copy')
                              "
                            >
                              <i class="ti ti-clipboard me-2"></i
                              >{{ $t("actions.copy") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              hasPrivilege('profiles_disable_profiles') &&
                                profile.enabled
                            "
                          >
                            <button
                              class="dropdown-item text-warning"
                              @click.prevent="disableData(profile)"
                            >
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disable") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              hasPrivilege('profiles_disable_profiles') &&
                                !profile.enabled
                            "
                          >
                            <button
                              class="dropdown-item text-success"
                              @click.prevent="enableData(profile)"
                            >
                              <i class="ti ti-shield me-2"></i
                              >{{ $t("actions.enable") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('profiles_delete_profiles')">
                            <button
                              class="dropdown-item text-danger"
                              @click.prevent="deleteData(profile)"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="profile.selected"
                        @click="selectData(profile)"
                      />
                    </td>
                    <td v-if="columns.name.enabled" scope="row" dir="ltr">
                      <a
                        :href="`?profile_id=${profile.id}`"
                        :class="{
                          disabled_ssr: !this.$store.getters.settings.license
                            .active,
                          'text-success': profile.type == 'prepaid',
                        }"
                        @click.prevent="openAddProfileDialog(profile)"
                        dir="ltr"
                        >{{ profile.name }}</a
                      >
                    </td>
                    <td v-if="columns.description.enabled">
                      <div dir="auto" :title="profile.description">
                        {{
                          profile.description != null &&
                          profile.description.length > 55
                            ? profile.description.substr(0, 55) + "..."
                            : profile.description
                        }}
                      </div>
                    </td>
                    <td v-if="columns.enabled.enabled">
                      <span
                        v-if="profile.enabled"
                        class="badge bg-label-success me-1"
                        >{{ $t("control.enabled") }}</span
                      >
                      <span v-else class="badge bg-label-danger me-1">{{
                        $t("control.disabled")
                      }}</span>
                    </td>
                    <td v-if="columns.service.enabled">
                      <div v-if="profile.service == 'hostspot'">Hotspot</div>
                      <div v-if="profile.service == 'ppp'">PPP</div>
                      <div v-if="profile.service == 'any'">PPP/Hotspot</div>
                    </td>
                    <td v-if="columns.type.enabled">
                      <div v-if="profile.type == 'subscribtion'">
                        {{ $t("profiles.subscription") }}
                      </div>
                      <div v-if="profile.type == 'prepaid'">
                        {{ $t("profiles.prepaid") }}
                      </div>
                    </td>
                    <td v-if="columns.price.enabled">
                      {{ profile.price + " " + settings.currency }}
                    </td>
                    <td v-if="columns.speed.enabled">
                      <span class="badge bg-label-info mb-2 me-1">{{
                        formatSpeed(profile.download_rate_kb)
                      }}</span>
                      <span class="badge bg-label-warning me-1">{{
                        formatSpeed(profile.upload_rate_kb)
                      }}</span>
                    </td>
                    <td v-if="columns.expiration.enabled">
                      <div v-if="profile.has_expiration">
                        {{
                          profile.expiration_value +
                            " " +
                            $t(`profiles.units.${profile.expiration_unit}`)
                        }}
                      </div>
                      <div v-else>{{ $t("control.unlimited") }}</div>
                    </td>
                    <td v-if="columns.quota.enabled">
                      <span v-if="!profile.has_traffic_limit">
                        <i class="ti ti-infinity ti-s"></i>
                        <!-- <span class=" ">{{ $t("control.unlimited") }}</span> -->
                      </span>
                      <span v-else>{{ profile.traffic_limit_value_mb }}</span>
                    </td>
                    <td v-if="columns.ip_pool.enabled">
                      {{ profile.ip_pool }}
                    </td>
                    <td v-if="columns.total_accounts.enabled">
                      <span class="badge bg-label-primary me-1">{{
                        profile.total_accounts
                      }}</span>
                    </td>
                    <td v-if="columns.online_accounts.enabled">
                      <span class="badge bg-label-success me-1">{{
                        profile.online_accounts
                      }}</span>
                    </td>
                    <td v-if="columns.open_speed.enabled">
                      <div v-if="profile.has_open_speed" class="flex">
                        <span class="badge bg-label-info mb-2 me-1">{{
                          profile.open_download_rate_mb + " Mb/s"
                        }}</span>
                        <span class="badge bg-label-warning me-1">{{
                          profile.open_upload_rate_mb + " Mb/s"
                        }}</span>
                      </div>
                      <div v-else>{{ $t("control.no") }}</div>
                    </td>
                    <td v-if="columns.shared.enabled">
                      {{
                        profile.shared ? $t("control.yes") : $t("control.no")
                      }}
                    </td>
                    <td v-if="columns.expiration_profile.enabled">
                      {{
                        profile.has_expiration_profile
                          ? $t("control.yes")
                          : $t("control.no")
                      }}
                    </td>
                    <td v-if="columns.allowed_nases.enabled">
                      <span
                        v-for="(nas, index) in profile.allowed_nases"
                        :key="index"
                        class="badge bg-label-primary me-1"
                        >{{ nas.shortname }}</span
                      >
                    </td>
                    <td v-if="columns.allowed_admins.enabled">
                      <div style="max-height: 50px; overflow-y: scroll;">
                        <span
                          v-for="(admin, index) in profile.allowed_admins"
                          :key="index"
                          class="badge bg-label-primary mb-1 me-1"
                          >{{ admin.email }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.custom_attributes.enabled">
                      {{ profile.custom_attributes }}
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ formatDateHours(profile.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profilesAdd from "../components/modals/profile-add.vue";
import columnsProfiles from "../components/modals/columns-profiles.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants";
import moment from "moment";
export default {
  components: {
    profilesAdd,
    columnsProfiles,
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDeleteAll: false,
      showDisable: false,
      showContext: false,
      showRenewAccounts: false,
      showAddProfile: false,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        name: "",
        service: "",
        type: "",
        enabled: "",
        price: "",
        speed: "",
        expiration: "",
        quota: "",
        ip_pool: "",
        online_accounts: "",
        total_accounts: "",
        open_speed: "",
        shared: "",
        expiration_profile: "",
        allowed_nases: "",
        allowed_admins: "",
        custom_attributes: "",
        created_at: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      selection_array: [],
      showColumnsSelect: false,
      columns: {
        name: { name: this.$t("profiles.name"), enabled: true, sort: false },
        service: {
          name: this.$t("profiles.service"),
          enabled: false,
          sort: false,
        },
        type: { name: this.$t("profiles.type"), enabled: false, sort: false },
        enabled: {
          name: this.$t("profiles.enabled"),
          enabled: false,
          sort: false,
        },
        price: { name: this.$t("profiles.price"), enabled: false, sort: false },
        speed: {
          name: this.$t("profiles.speed_limit"),
          enabled: true,
          sort: false,
        },
        expiration: {
          name: this.$t("profiles.expiration"),
          enabled: true,
          sort: false,
        },
        quota: { name: this.$t("profiles.quota"), enabled: true, sort: false },
        ip_pool: {
          name: this.$t("profiles.ip_pool"),
          enabled: false,
          sort: false,
        },
        total_accounts: {
          name: this.$t("profiles.total_accounts"),
          enabled: false,
          sort: false,
        },
        online_accounts: {
          name: this.$t("profiles.online_accounts"),
          enabled: false,
          sort: false,
        },
        allowed_nases: {
          name: this.$t("profiles.allowed_nases"),
          enabled: false,
          sort: false,
        },
        allowed_admins: {
          name: this.$t("nases.allowed_admins"),
          enabled: true,
          sort: false,
        },
        shared: {
          name: this.$t("profiles.shared"),
          enabled: false,
          sort: false,
        },
        open_speed: {
          name: this.$t("profiles.open_speed"),
          enabled: false,
          sort: false,
        },
        expiration_profile: {
          name: this.$t("profiles.expiration_profile"),
          enabled: false,
          sort: false,
        },
        custom_attributes: {
          name: this.$t("profiles.custom_attributes"),
          enabled: false,
          sort: false,
        },
        created_at: {
          name: this.$t("control.created_at"),
          enabled: false,
          sort: false,
        },
        description: {
          name: this.$t("profiles.description"),
          enabled: true,
          sort: false,
        },
      },
      autoUpdate: false,
      debounce: null,
    };
  },
  async created() {
    this.prepareFilters();
    this.prepareColumns();
    if (this.$route.query.name) {
      this.filters.name = this.$route.query.name;
      this.columns.name.enabled = true;
    }
    if (this.$route.query.profile_id) {
      this.openAddProfileDialog({ id: this.$route.query.profile_id });
    }
    await this.applyFilters();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get("profiles");
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    async openAddProfileDialog(profile = null, operation = "new") {
      this.showAddProfile = true;
      if (profile) {
        this.$router.push({
          query: { profile_id: profile.id, operation: operation },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-profile");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddProfile = false;
      });
      modalInstance.show();
    },
    prepareFilters() {
      var filters = localStorage.getItem("profiles_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("profiles_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: {
            name: this.$t("profiles.name"),
            enabled: cols[0].enabled,
            sort: false,
          },
          service: {
            name: this.$t("profiles.service"),
            enabled: cols[1].enabled,
            sort: false,
          },
          type: {
            name: this.$t("profiles.type"),
            enabled: cols[2].enabled,
            sort: false,
          },
          enabled: {
            name: this.$t("profiles.enabled"),
            enabled: cols[3].enabled,
            sort: false,
          },
          price: {
            name: this.$t("profiles.price"),
            enabled: cols[4].enabled,
            sort: false,
          },
          speed: {
            name: this.$t("profiles.speed_limit"),
            enabled: cols[5].enabled,
            sort: false,
          },
          expiration: {
            name: this.$t("profiles.expiration"),
            enabled: cols[6].enabled,
            sort: false,
          },
          quota: {
            name: this.$t("profiles.quota"),
            enabled: cols[7].enabled,
            sort: false,
          },
          ip_pool: {
            name: this.$t("profiles.ip_pool"),
            enabled: cols[8].enabled,
            sort: false,
          },
          total_accounts: {
            name: this.$t("profiles.total_accounts"),
            enabled: cols[9].enabled,
            sort: false,
          },
          online_accounts: {
            name: this.$t("profiles.online_accounts"),
            enabled: cols[10].enabled,
            sort: false,
          },
          allowed_nases: {
            name: this.$t("profiles.allowed_nases"),
            enabled: cols[11].enabled,
            sort: false,
          },
          allowed_admins: {
            name: this.$t("nases.allowed_admins"),
            enabled: cols[12] != null ? cols[12].enabled : true,
            sort: false,
          },
          shared: {
            name: this.$t("profiles.shared"),
            enabled: cols[13] != null ? cols[13].enabled : false,
            sort: false,
          },
          open_speed: {
            name: this.$t("profiles.open_speed"),
            enabled: cols[14] != null ? cols[14].enabled : false,
            sort: false,
          },
          expiration_profile: {
            name: this.$t("profiles.expiration_profile"),
            enabled: cols[15] != null ? cols[15].enabled : false,
            sort: false,
          },
          custom_attributes: {
            name: this.$t("profiles.custom_attributes"),
            enabled: cols[16] != null ? cols[16].enabled : false,
            sort: false,
          },
          created_at: {
            name: this.$t("control.created_at"),
            enabled: cols[17] != null ? cols[17].enabled : false,
            sort: false,
          },
          description: {
            name: this.$t("profiles.description"),
            enabled: cols[18] != null ? cols[18].enabled : false,
            sort: false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "profiles?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.service != "")
        requestString += `&service=${this.filters.service}`;
      if (this.filters.type != "")
        requestString += `&type=${this.filters.type}`;
      if (this.filters.price != "")
        requestString += `&price=${this.filters.price}`;
      if (this.filters.enabled != "")
        requestString += `&enabled=${this.filters.enabled}`;
      if (this.filters.speed != "")
        requestString += `&speed=${this.filters.speed}`;
      if (this.filters.quota != "")
        requestString += `&quota=${this.filters.quota}`;
      if (this.filters.expiration != "")
        requestString += `&expiration=${this.filters.expiration}`;
      if (this.filters.ip_pool != "")
        requestString += `&ip_pool=${this.filters.ip_pool}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.online_accounts != "")
        requestString += `&online_accounts=${this.filters.online_accounts}`;
      if (this.filters.open_speed != "")
        requestString += `&open_speed=${this.filters.open_speed}`;
      if (this.filters.shared != "")
        requestString += `&shared=${this.filters.shared}`;
      if (this.filters.expiration_profile != "")
        requestString += `&expiration_profile=${this.filters.expiration_profile}`;
      if (this.filters.custom_attributes != "")
        requestString += `&custom_attributes=${this.filters.custom_attributes}`;
      if (this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.allowed_nases != "")
        requestString += `&allowed_nases=${this.filters.allowed_nases}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      if (this.columns.total_accounts.enabled)
        requestString += `&total_accounts=1`;
      if (this.columns.online_accounts.enabled)
        requestString += `&online_accounts=1`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("profiles_filters", JSON.stringify(this.filters));
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem(
      //       "profiles_filters",
      //       JSON.stringify(this.filters)
      //     );
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    editData(selectedData) {
      this.$router.push(`/profiles/${selectedData.id}/edit`);
    },
    async deleteData(profile) {
      this.$swal({
        title:
          this.$t("profiles.delete_profile_permanently") + " " + profile.name,
        text: this.$t(
          "profiles.this_will_delete_profile_permanently_and_all_accounts_and_cards_connected_to_it_you_wont_be_able_to_get_them_back",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("profiles.yes_am_sure_delete_them"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`profiles/${profile.id}`);
            if (response.status == 200) {
              this.applyFilters();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("profiles.profile_has_been_deleted_successfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async disableData(profile) {
      this.$swal({
        title:
          this.$t("profiles.disable_profile_temporarily") + " " + profile.name,
        text: this.$t("profiles.this_will_disable_profile_temporarily"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`profiles/${profile.id}/disable`);
            if (response.status == 200) {
              this.applyFilters();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("profiles.profile_disabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async enableData(profile) {
      this.$swal({
        title: this.$t("profiles.enable_profile") + " " + profile.name,
        text: this.$t("profiles.this_will_enable_profile"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`profiles/${profile.id}/disable`);
            if (response.status == 200) {
              this.applyFilters();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("profiles.profile_enabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    formatDateHours(date) {
      //todo fix UTC BUG
      if (date == "never" || date == "" || date == null) return "N/A";
      return moment(date)
        .add(3, "hours")
        .format("DD-MM-YYYY hh:mm");
    },
    formatSpeed(speed) {
      if (speed < 0) return "∞";
      if (speed > 1023) return speed / 1024 + " Mb/s";
      else return speed + " Kb/s";
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async groupDelete() {
      const response = await axios.post(`profiles/group`, {
        profiles: this.selection_array,
      });
      if (response.status == 200) {
        this.fetchData();
        this.showDeleteAll = false;
        this.$router.push({ query: { success: "success" } });
      }
    },
    updateColumns(updated) {
      localStorage.setItem(
        "profiles_columns",
        JSON.stringify(Object.values(this.columns)),
      );
      this.applyFilters();
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    sort(param) {
      this.sort_col = param;
      if (param == "traffic_limit_value_mb") param = "quota";
      if (param == "expiration_value") param = "expiration";
      if (param == "download_rate_kb") param = "speed";
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    sort_expiration() {
      this.sort_col = "expiration_value";
      if (!this.columns.expiration.sort) {
        this.sort_dir = "ASC";
        this.dataList.sort((a, b) =>
          a.expiration_value > b.expiration_value
            ? 1
            : b.expiration_value > a.expiration_value
            ? -1
            : 0,
        );
        this.columns.expiration.sort = true;
      } else {
        this.sort_dir = "DESC";
        this.dataList.sort((a, b) =>
          a.expiration_value < b.expiration_value
            ? 1
            : b.expiration_value < a.expiration_value
            ? -1
            : 0,
        );
        this.columns.expiration.sort = false;
      }
    },
    sort_speed() {
      this.sort_col = "download_rate_kb";
      if (!this.columns.speed.sort) {
        this.sort_dir = "ASC";
        this.dataList.sort((a, b) =>
          a.download_rate_kb + a.upload_rate_kb >
          b.download_rate_kb + b.upload_rate_kb
            ? 1
            : b.download_rate_kb + b.upload_rate_kb >
              a.download_rate_kb + a.upload_rate_kb
            ? -1
            : 0,
        );
        this.columns.speed.sort = true;
      } else {
        this.sort_dir = "DESC";
        this.dataList.sort((a, b) =>
          a.download_rate_kb + a.upload_rate_kb <
          b.download_rate_kb + b.upload_rate_kb
            ? 1
            : b.download_rate_kb + b.upload_rate_kb <
              a.download_rate_kb + a.upload_rate_kb
            ? -1
            : 0,
        );
        this.columns.speed.sort = false;
      }
    },
    sort_quota() {
      this.sort_col = "traffic_limit_value_mb";
      if (!this.columns.quota.sort) {
        this.sort_dir = "ASC";
        this.dataList.sort((a, b) =>
          a.traffic_limit_value_mb > b.traffic_limit_value_mb
            ? 1
            : b.traffic_limit_value_mb > a.traffic_limit_value_mb
            ? -1
            : 0,
        );
        this.columns.quota.sort = true;
      } else {
        this.sort_dir = "DESC";
        this.dataList.sort((a, b) =>
          a.traffic_limit_value_mb < b.traffic_limit_value_mb
            ? 1
            : b.traffic_limit_value_mb < a.traffic_limit_value_mb
            ? -1
            : 0,
        );
        this.columns.quota.sort = false;
      }
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("profiles_filters", JSON.stringify(this.filters));
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
